<template>
  <div>
    <Navbar></Navbar>
    <div class="container mt-3 mt-lg-5">
      <!-- TITLE-->
      <div class="row mb-3">
        <div class="col-md-12 text-center">
          <h4 class="fw-bold">Pricing</h4>
        </div>
      </div>
      <div class="row justify-content-center mb-3">
        <div class="col-lg-8 mb-3">
          <div class="card-group">
            <div class="card card-outline translate-up">
              <div class="card-header d-flex justify-content-around align-items-center flex-wrap my-2">
                <i class="material-icons text-gradient-animate mdc-68">add_box</i>
                <div class="">
                  <h4>Free</h4>
                  <h6 class="">No account</h6>
                </div>
              </div>
              <div class="card-body">
                <ul class="list-group list-unstyled">
                  <li class="list-group-item list-pricing"><i class="material-icons-outlined text-success">check</i>
                    Access to every Colorffy's tools.
                  </li>
                  <li class="list-group-item list-pricing"><i class="material-icons-outlined text-success">check</i> No
                    account.
                  </li>
                </ul>
              </div>
              <div class="card-footer d-grid gap-2">
                <router-link to="/sign-up" class="btn btn-primary ripple py-3">Explore
                  <i class="material-icons-outlined">arrow_right_alt</i>
                </router-link>
              </div>
            </div>

            <div class="card card-outline translate-up">
              <div class="card-header d-flex justify-content-around align-items-center flex-wrap my-2">
                <i class="material-icons text-gradient-animate mdc-68">widgets</i>
                <div class="">
                  <h4>Monthly</h4>
                  <h6 class="">$1.99 USD</h6>
                </div>
              </div>
              <div class="card-body">
                <ul class="list-group list-unstyled">
                  <li class="list-group-item list-pricing"><i class="material-icons-outlined text-success">check</i>
                    Access to every Colorffy's tools.
                  </li>
                  <li class="list-group-item list-pricing"><i class="material-icons-outlined text-success">check</i>
                    Save
                    your favorites gradients and palettes.
                  </li>
                  <li class="list-group-item list-pricing"><i class="material-icons-outlined text-success">check</i>
                    Create and save unlimited gradients.
                  </li>
                  <li class="list-group-item list-pricing"><i class="material-icons-outlined text-success">check</i> Get
                    Android colors from palettes and gradients.
                  </li>
                </ul>
              </div>
              <div class="card-footer d-grid gap-2">
                <router-link to="/sign-up" class="btn btn-primary ripple py-3">Get Started
                  <i class="material-icons-outlined">arrow_right_alt</i>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Navbar from "@/components/includes/Navbar";
import Footer from "@/components/includes/Footer";

export default {
  name: 'Pricing',
  metaInfo: {
    title: 'Pricing',
  },
  components: {Footer, Navbar}
}
</script>